import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import Vant from "vant";
import "vant/lib/index.css";
import "@vant/touch-emulator";
// console.log(Vant)
Vue.use(Vant);

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

import * as filters from "./filters"; // global filters
// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// 注册公共的组件
import customCom from "./components/index.js";
Vue.use(customCom); //使用自定义组件库

import loading from "./components/loading/loading";
Vue.use(loading);

// select
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("vSelect", vSelect);

// tooltip
import { VTooltip } from "floating-vue";
import "floating-vue/dist/style.css";
Vue.directive("tooltip", VTooltip);

// 水印指令
import { watermarkDirective } from "@/directives/watermark";
Vue.directive("watermark", watermarkDirective);

Array.prototype.findValue = function (options) {
  const {
    value,
    valueName = "value",
    labelName = "label",
    defaultValue = "-",
    childrenName,
  } = options;
  let res = null;
  for (let i = 0; i < this.length; i++) {
    if (this[i][valueName] === value) {
      res = this[i][labelName];
      break;
    } else if (
      childrenName &&
      Array.isArray(this[i][childrenName]) &&
      this[i][childrenName].length
    ) {
      res = this[i][childrenName].findValue({
        ...options,
        defaultValue: null,
      });
      if (res != null) break;
    }
  }
  return res == null ? defaultValue : res;
};

Object.defineProperty(Array.prototype, "findValue", {
  enumerable: false,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
